export { default as useLifestyleColors } from './useLifestyleColors';
